"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginStartup = void 0;
var tslib_1 = require("tslib");
var basePlugin_1 = tslib_1.__importDefault(require("../base/basePlugin"));
var typings_1 = require("../typings");
var const_1 = require("../utils/const");
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var util_1 = require("../utils/util");
var defaultConfig = {
    disable: false,
    sampleRate: 100,
};
var PluginStartup = /** @class */ (function (_super) {
    tslib_1.__extends(PluginStartup, _super);
    function PluginStartup(queue, config) {
        if (config === void 0) { config = defaultConfig; }
        var _this = _super.call(this, queue, config) || this;
        _this.name = PluginStartup.id;
        _this.config = util_1.extend(defaultConfig, _this.config);
        return _this;
    }
    PluginStartup.prototype.parsePerformanceTiming = function () {
        var _this = this;
        setTimeout(function () {
            try {
                if (!performance)
                    return;
                // 获取  fcp fp 时间
                _this.handlePaintEntry();
                // 获取 performance timing 时间
                var timing = performance.timing;
                var navStart = timing.navigationStart;
                var tags = {};
                var pointArr = [
                    'unloadEventStart',
                    'unloadEventEnd',
                    'redirectStart',
                    'redirectEnd',
                    'fetchStart',
                    'domainLookupStart',
                    'domainLookupEnd',
                    'connectStart',
                    'connectEnd',
                    'requestStart',
                    'responseStart',
                    'responseEnd',
                    'domLoading',
                    'domInteractive',
                    'domContentLoadedEventStart',
                    'domContentLoadedEventEnd',
                    'domComplete',
                    'loadEventStart',
                ];
                for (var _i = 0, pointArr_1 = pointArr; _i < pointArr_1.length; _i++) {
                    var key = pointArr_1[_i];
                    tags[key] = util_1.calcTime(navStart, timing[key]);
                }
                tags.dns = util_1.calcTime(timing.domainLookupStart, timing.domainLookupEnd);
                tags.tcp = util_1.calcTime(timing.connectStart, timing.connectEnd);
                tags.response = util_1.calcTime(timing.requestStart, timing.responseEnd);
                _this.addData({
                    type: const_1.METRICS_LOAD,
                    ts: Date.now(),
                    value: util_1.calcTime(navStart, timing.loadEventEnd),
                    tags: tags,
                });
            }
            catch (error) {
                logger_1.default.log('获取 performance timing error', error);
            }
        }, 0);
    };
    PluginStartup.prototype.init = function () {
        // 上报页面启动起点 计算启动阶段留存
        this.addData({
            type: const_1.METRICS_START,
            value: 1,
            ts: Date.now(),
        });
        if (document && document.readyState === 'complete') {
            this.parsePerformanceTiming();
        }
        else {
            window.addEventListener('load', this.parsePerformanceTiming.bind(this));
        }
    };
    PluginStartup.prototype.addPaintData = function (metrics, entry) {
        this.addData({
            type: metrics,
            value: entry.startTime,
            ts: Date.now(),
        });
    };
    PluginStartup.prototype.handlePaintEntry = function () {
        var _this = this;
        var fpFounded = false;
        var fcpFounded = false;
        var performanceEntries = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('paint');
        if (performanceEntries && performanceEntries.length) {
            performanceEntries.forEach(function (performanceEntry) {
                if (performanceEntry.name === 'first-contentful-paint') {
                    _this.addPaintData(const_1.METRICS_FCP, performanceEntry);
                    fcpFounded = true;
                }
                if (performanceEntry.name === 'first-paint') {
                    _this.addPaintData(const_1.METRICS_FP, performanceEntry);
                    fpFounded = true;
                }
            });
        }
        if (!(fcpFounded && fpFounded)) {
            var ob_1 = util_1.addPerformanceObserver('paint', function (list) {
                for (var _i = 0, _a = list.getEntries(); _i < _a.length; _i++) {
                    var entry = _a[_i];
                    if (!fpFounded && entry.name === 'first-paint') {
                        _this.addPaintData(const_1.METRICS_FP, entry);
                        fpFounded = true;
                    }
                    if (!fcpFounded && entry.name === 'first-contentful-paint') {
                        _this.addPaintData(const_1.METRICS_FCP, entry);
                        fcpFounded = true;
                    }
                }
                if (fcpFounded && fpFounded) {
                    ob_1 === null || ob_1 === void 0 ? void 0 : ob_1.disconnect();
                }
            });
        }
    };
    PluginStartup.id = typings_1.PLUGIN_NAME.STARTUP;
    return PluginStartup;
}(basePlugin_1.default));
exports.PluginStartup = PluginStartup;
//# sourceMappingURL=startup.js.map